export const DEFAULT_ENVIRONMENT_DISPLAY_NAME = 'Environment';
export const DEFAULT_UNIT_ID_DISPLAY_NAME = 'Unit ID';
export const UNIT_ID_LABEL_KEY = 'unitId';
export const ENVIRONMENT_LABEL_KEY = 'environment';
export const UNIT_ID_LABEL_PREFIX = 'unitid:';
export const ENVIRONMENT_LABEL_PREFIX = 'environment:';
export const WARNING_EMOJI = '⚠️';
export const LABEL_DELIMITER = ':';
